import { render, staticRenderFns } from "./TransferenciaPosseDefinitivaPasso4.vue?vue&type=template&id=50eeb4b6&lang=html&"
import script from "./TransferenciaPosseDefinitivaPasso4.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPosseDefinitivaPasso4.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciaPosseDefinitivaPasso4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaPasso4.vue
// module id = 1591
// module chunks = 28